<section class="page-section" id="jobs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h2 class="section-heading text-uppercase">Application</h2>
        <h3 class="section-subheading">Enter your details below</h3>
      </div>
    </div>
    <div>
    <form>
        <mat-form-field appearance='outline'>
            <mat-label >Surname </mat-label>
            <input matInput placeholder="Surname"/>
        </mat-form-field>
    </form>
    </div>
    <div>
      <button mat-ripple class="btn btn-fsp" routerLink="./apply" >Apply</button>
    </div>
  </div>
</section>
